import { useMutation, useQuery } from "react-query"
import { useToast } from "../../../hooks/usetoast";
import { queryClient } from "../../../config";
import DataService from '../../../config/DataServices'

const { getRequest, postRequest, deleteRequest } = DataService()
export const useWhiteipList = ({ status, page, size, searchText, sortBy, sortOrder }) => {
    return useQuery({
        queryKey: ["whiteip-list", status, page, size, searchText, sortBy, sortOrder],
        queryFn: () => {
            return getRequest(`/ip?status=${status}&page=${page}&size=${size}&search=${searchText}&sortBy=${sortBy}&sortOrder=${sortOrder}`)
        }
    })
}

export const useCheckAdminAccess = () => {
    return useMutation({
        mutationFn: (data) => postRequest("/get-module", { ...data }),
        onError: (error) => {
        }
    });
};

export const useAddwhiteip = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return postRequest("/ip", { ...data })
        },
        onError: error => {
            return toast.error(error?.message)
        },
        onSuccess: success => {
            queryClient.refetchQueries('whiteip-list')
            queryClient.refetchQueries('check-ip')
            return toast.success(success?.data?.message)
        }
    })
}

export const useDeletewhiteip = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return deleteRequest(`/ip/${data._id}`)
        },
        onError: error => {
            return toast.error(error?.message)
        },
        onSuccess: success => {
            queryClient.refetchQueries("whiteip-list");
            queryClient.refetchQueries('check-ip')
            return toast.success(success?.data?.message)
        }
    })
}

export const useGetipList = () => {
    return useQuery({
        queryKey: ["get-ip-list"],
        queryFn: () => {
            return getRequest('/get-ip')
        }
    })
}